<div class="Sessions">
    <div class="container">
        <div class="head">
            <h2>Exclusive CAT 2025 Sessions</h2>
        </div>
        <ul class="row-cols-md-5 flex-row flex-nowrap othermba-exam">
            <li class="col px-md-2 px-2" *ngFor="let session of Sessionslist; let i = index">
                <div class="session-card">
                    <h6> {{session.step}}</h6>
                    <div class="img-div" (click)="playVideo(session.url, i)">
                        <img src="{{session.img}}" alt="iQuanta session ">
                        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor"
                            class="bi bi-play-circle-fill" viewBox="0 0 16 16">
                            <path
                                d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                        </svg>
                    </div>
                    <h6>{{session.title}}</h6>
                </div>
            </li>
        </ul>
    </div>
</div>